import { render, staticRenderFns } from "./UserBlockingModal.vue?vue&type=template&id=d2528128&"
import script from "./UserBlockingModal.vue?vue&type=script&lang=js&"
export * from "./UserBlockingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports